export default __webpack_public_path__ + "static/media/sj-1-rMIN.2df48978.avif";